export const parseBlockID = (id: string | undefined) => {
  return id ? `block-${id}` : undefined;
};
